__turbopack_context__.v({
  "button": "U7SQbq_button",
  "charCounter": "U7SQbq_charCounter",
  "content-container": "U7SQbq_content-container",
  "content-container-items": "U7SQbq_content-container-items",
  "content-container-items-caption": "U7SQbq_content-container-items-caption",
  "content-container-items-circle": "U7SQbq_content-container-items-circle",
  "form-actions": "U7SQbq_form-actions",
  "form-comment": "U7SQbq_form-comment",
  "form-counter": "U7SQbq_form-counter",
  "title": "U7SQbq_title",
  "wishlist-form-container": "U7SQbq_wishlist-form-container",
  "wishlist-form-sidebar": "U7SQbq_wishlist-form-sidebar",
});
